import { createFileRoute } from "@tanstack/react-router";

import { TicketDetail } from "@/founder/support/TicketDetail";

export const Route = createFileRoute("/founder/support/$ticketId")({
    component: RouteComponent,
});

function RouteComponent() {
    const { ticketId } = Route.useParams();
    return <TicketDetail ticketId={ticketId} />;
}
